<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-list two-line subheader>
          <v-subheader inset>Settings</v-subheader>
          <v-list-tile>
            <v-text-field label="Company Code" v-model="company"></v-text-field>
          </v-list-tile>
          <v-list-tile>
            <v-text-field label="Remote Server" v-model="server"></v-text-field>
          </v-list-tile>
          <v-list-tile>
            <v-text-field label="Auto Signout Interval (Minutes)" v-model="signoutInterval" type="number" @change="setSignoutInterval"></v-text-field>
          </v-list-tile>
          <v-list-tile avatar v-for="item in items" v-bind:key="item.title" @click="item.action">
            <v-list-tile-avatar>
              <v-icon v-bind:class="[item.iconClass]">{{ item.icon }}</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-card flat>
          <v-card-title>
            <v-layout row wrap>
              <v-flex xs12>
                <span class="subheading">Camera Quality</span>
              </v-flex>
              <v-flex xs12>
                <v-slider prepend-icon="camera" min="20" class="px-3" v-model="cameraQuality" thumb-label step="10" ticks></v-slider>
              </v-flex>
            </v-layout>
          </v-card-title>
        </v-card>
        <v-card flat>
          <v-card-title v-if="showAppMode">
            <v-layout row wrap>
              <v-flex xs12>
                <span class="subheading font-weight-medium">Application Mode</span>
              </v-flex>
              <v-flex xs12>
                <v-radio-group v-model="applicationMode" column>
                  <v-radio label="Normal" value="tanda" color="primary"></v-radio>
                  <v-radio label="Tacho Day" value="tacho" color="primary"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-card-title>
        </v-card>
        <v-card flat>
          <v-card-title v-if="!secureMenu">
            <v-layout row wrap>
              <v-flex xs12>
                <span class="subheading font-weight-medium">Location Settings</span>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="secureMenuCode" label="Enter Code"></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-title>
        </v-card>
        <v-card flat>
          <v-card-title v-if="secureMenu">
            <v-layout row wrap>
              <v-flex xs12>
                <span class="subheading font-weight-medium">Set location For this machine</span>
                <v-text-field v-model="lat" label="Latitude"/>
                <v-text-field v-model="long" label="Longitude"/>
              </v-flex>
            </v-layout>
          </v-card-title>
        </v-card>
      </v-card>
    </v-flex>
    <v-snackbar v-model="snackbar">
      {{snackbarText}}
      <v-btn dark flat @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
  import idb from 'idb'
  export default {
    data () {
      return {
        items: [
          { icon: 'history', iconClass: 'grey lighten-1 white--text', title: 'Reset', subtitle: 'Refresh the app to get the latest version', action: this.resetApp }
        ],
        snackbar: false,
        snackbarText: '',
        cameraQuality: 0,
        company: this.$store.getters.company,
        server: localStorage.getItem('remoteServer') !== null && localStorage.getItem('remoteServer') !== undefined ? localStorage.remoteServer : 'https://cwelite.aquariusit.com',
        applicationMode: localStorage.getItem('applicationMode') !== null && localStorage.getItem('applicationMode') !== undefined ? localStorage.applicationMode : 'tanda',
        signoutInterval: localStorage.getItem('signoutInterval') !== null && localStorage.getItem('signoutInterval') !== undefined ? localStorage.signoutInterval : 0,
        secureMenuCode: null,
        secureMenu: false,
        long: localStorage.getItem('long') || null,
        lat: localStorage.getItem('lat') || null
      }
    },
    watch: {
      cameraQuality: function (val) {
        localStorage.setItem('cameraQuality', val)
      },
      secureMenuCode: function (val) {
        if (val === '767883!@') {
          this.secureMenu = true
        }
      },
      company: function (val) {
        this.$store.dispatch('checkCompany', val)
      },
      server: function (val) {
        this.$store.dispatch('setURL', val)
        localStorage.setItem('remoteServer', val)
      },
      lat: function (val) {
        localStorage.setItem('lat', val)
      },
      long: function (val) {
        localStorage.setItem('long', val)
      },
      applicationMode: function (val) {
        this.$store.dispatch('setApplicationMode', val)
        localStorage.setItem('applicationMode', val)
      }
    },
    created () {
      this.cameraQuality = localStorage.getItem('cameraQuality') !== null && localStorage.getItem('cameraQuality') !== undefined ? localStorage.cameraQuality : 50
    },
    methods: {
      resetApp () {
        navigator.serviceWorker.getRegistrations()
          .then(function (registrations) {
            for (let registration of registrations) {
              registration.unregister()
            }
          })
          .then(function (boolean) {
            caches.delete('tanda-cache').then(function (boolean) {
              window.location.reload(true)
            })
          })
      },
      clearApp () {
        this.snackbar = true
        this.snackbarText = 'Clearing Data'
        idb.delete('tanda-db').then(() => {
          this.snackbar = true
          this.snackbarText = 'Data Cleared'
        })
      },
      setSignoutInterval () {
        this.$store.dispatch('setSignoutInterval', this.signoutInterval)
        localStorage.setItem('signoutInterval', this.signoutInterval)
      }
    },
    computed: {
      showAppMode () {
        const disabledCompanies = ['freshlinc']
        if (this.company && disabledCompanies.indexOf(this.company.toLowerCase()) > -1) {
          return false
        } else {
          return true
        }
      }
    }
  }
</script>

<style>
.radio + .radio {
    margin-left: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Settings.vue